export interface IHistoryAccount {
  currencyBefore: boolean;
  currencyCode: string;
  currencySymbol: string;
  firstName: string;
  fullName: string;
  lastName: string;
  rowCount: number;
  screenName: string;
  userId: string;
}

export interface IHistoryGame {
  balance: number;
  dataTimeStart: string;
  day: string;
  gameId: number;
  gameUrl: string;
  label: string;
  maxcap: boolean;
  netAmount: number;
  simulationStatus: HistorySimulationStatus;
  stake: number;
  type: string;
}

export enum HistorySimulationStatus {
  Cancelled = '0',
  Simulated = '1',
  Default = '2',
}

export interface ISingleHistory {
  game: ISingleHistoryGame;
  seats: ISingleHistorySeat[];
  bets: ISingleHistoryBet[];
}

export interface ISingleHistoryGame {
  cancelled: boolean;
  simulated: {
    newResultCode: string;
    cardValues?: string;
  };
  date: string;
  id: number;
  name: string;
  netAmount: number;
  roundId: number;
  totalBet: number;
  type: string;
  additional: {
    bingoGameEvents: never;
    bobDetails: never;
    kpbGameDetails: never;
    megaBaccaratGameEvents: never;
    rngSlots: never;
    rouletteDetails: never;
    snlGameDetails: never;
    sweetbonanza: never;
    taGameSummary: never;
  };
  tableVariant: string;
}

// Interface is used only for parsing server data
export interface ITodayHistoryData {
  account: IHistoryAccount;
  day: {
    date: string;
    games: {
      game: IHistoryGame | IHistoryGame[];
    } | null;
  };
}

// Interface is used only for parsing server data
export interface IOlderHistoryData {
  account: IHistoryAccount;
  day: Array<{
    date: string;
    games: {
      game: IHistoryGame[];
    };
  }>;
}

export interface ISingleHistoryBet {
  amount: string;
  description: string;
  maxcap: string;
  megawin: string;
  netCash: string;
  player: string;
  playerMul?: string;
  result: string;
}

export interface ISingleHistorySeat {
  name: string;
  dealer: string;
  hand: never;
  number: string;
}

// Interface is used only for parsing server data
export interface ISingleHistoryData {
  games: {
    account: IHistoryAccount;
    game: {
      bet: ISingleHistoryBet | ISingleHistoryBet[];
      currency: string;
      dataTimeStart: string;
      gameCancelled: string;
      simulationElement: never;
      gameId: string;
      label: string;
      maxcap: string;
      netAmount: string;
      roundId: string;
      seat: ISingleHistorySeat | ISingleHistorySeat[];
      stake: string;
      totalPayoff: string;
      type: string;
      tableVariant: string;

      bingoGameEvents: never;
      bobDetails: never;
      kpbGameDetails: never;
      megaBaccaratGameEvents: never;
      rngSlots: never;
      rouletteDetails: never;
      snlGameDetails: never;
      sweetbonanza: never;
      taGameSummary: never;
    };
  };
}
